import APIHandler from './apiHandler';

import {API_ROUTES} from './const';

const authAPI = {
  doLogin: ({ email, password }) =>
    APIHandler.post({ url: API_ROUTES.AUTH, body: { email, password } }).then(response => {

        return response;
    }),

  requestPasswordReset: ({ email }) =>
    APIHandler.post({ url: API_ROUTES.REQUEST_PASSWORD_RESET, body: { email } }).then(response => response),

  resetPassword: ({ hash, password }) =>
    APIHandler.post({ url: API_ROUTES.RESET_PASSWORD, body: { hash, password } }).then(response => response),
};

export default authAPI;